import settingsApi from '~/services/plataforma/institutionConfiguration';

export default {
  actionGetInstitutionConfiguration({ commit }) {
    return settingsApi.getInstitutionConfiguration()
      .then((response) => {
        commit('SET_INSTITUTION_CONFIGURATION', response.data);

        return Promise.resolve(response.data);
      })
      .catch((error) => {
        return Promise.reject(error.response);
      });
  },
  actionGetCategoryTypes() {
    return settingsApi.getCategoryTypes()
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((error) => {
        return Promise.reject(error.response.data.error.message);
      });
  },
  async actionGetTopicTypes({ state, commit }, { refresh = false } = {}) {
    if (state.topicTypesRequest) {
      return state.topicTypesRequest;
    }

    if (!refresh && Object.keys(state.topicTypes).length) {
      return Promise.resolve(state.topicTypes);
    }

    const request = settingsApi.getTopicTypes()
      .then((response) => {
        const mappedTypes = response.data.reduce((acc, curr) => {
          acc[curr.id] = curr;
          return acc;
        }, {});
        commit('SET_TOPIC_TYPES', mappedTypes);
        return mappedTypes;
      })
      .finally(() => {
        if (state.topicTypesRequest === request) {
          commit('SET_TOPIC_TYPES_REQUEST', null);
        }
      });

    commit('SET_TOPIC_TYPES_REQUEST', request);
    return request;
  },
  async actionGetTopicTypesIcons({ state, dispatch, commit }) {
    if (Object.keys(state.topicTypesIcons).length) {
      return state.topicTypesIcons;
    }

    const types = Object.values(await dispatch('actionGetTopicTypes'));
    const mappedTypes = types.reduce((acc, curr) => {
      acc[curr.id] = curr.icon;
      return acc;
    }, {});
    commit('SET_TOPIC_TYPES_ICONS', mappedTypes);

    return mappedTypes;
  },
  async actionGetTopicTypesColors({ state, dispatch, commit }) {
    if (Object.keys(state.topicTypesColors).length) {
      return state.topicTypesColors;
    }

    const types = Object.values(await dispatch('actionGetTopicTypes'));
    const mappedTypes = types.reduce((acc, curr) => {
      acc[curr.id] = curr.color;
      return acc;
    }, {});
    commit('SET_TOPIC_TYPES_COLORS', mappedTypes);

    return mappedTypes;
  },
  async actionGetTopicTypesNames({ state, dispatch, commit }) {
    if (Object.keys(state.topicTypesNames).length) {
      return state.topicTypesNames;
    }

    const types = Object.values(await dispatch('actionGetTopicTypes'));
    const mappedTypes = types.reduce((acc, curr) => {
      acc[curr.id] = curr.name;
      return acc;
    }, {});
    commit('SET_TOPIC_TYPES_NAMES', mappedTypes);

    return mappedTypes;
  },
  async actionInitTopicTypes({ dispatch }) {
    await dispatch('actionGetTopicTypes');

    const promises = [
      dispatch('actionGetTopicTypesIcons'),
      dispatch('actionGetTopicTypesColors'),
      dispatch('actionGetTopicTypesNames')
    ];

    return Promise.all(promises);
  },
  actionGetBatchEditCategoryTypes(_, { contractResourceAlias }) {
    return settingsApi.getCategoryTypes()
      .then((response) => {
        return Promise.resolve(response.data.filter(({ isVisibleInBatches, isVisibleForLiteContractResource }) => {
          if (!isVisibleInBatches) {
            return false;
          }

          if (contractResourceAlias === 'lite') {
            return isVisibleForLiteContractResource;
          }

          return true;
        }));
      })
      .catch((error) => {
        return Promise.reject(error.response.data.error.message);
      });
  }
};
